import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import zeplinColor from 'theme/Color';

const SectionLoader = () => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '14px',
        backgroundColor: zeplinColor.Neutral1,
        padding: '24px',
        '&:focus': {
          outline: 'none',
        },
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress sx={{ color: zeplinColor.BasicBlack }} size={80} />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src='/assets/a-a-loader.svg' alt='loading' width={32} height={32} />
        </Box>
      </Box>
    </Box>
  );
};

export default SectionLoader;
